import React, { useState } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useTranslation } from 'react-i18next';
import { GET_PURCHASE_NUMBER, PURCHASE_ORDER } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import ProductCal from '../layout/ProductCal';
import Helper from '../../../helper/Helper';
import Alert from '../../../feature/Alert';
import { useNavigate } from 'react-router-dom';
import SelectVendor from '../layout/SelectVendor';
import { useEffect } from 'react';


export default function PurchaseOrder() {

     const [state_id, setState] = useState('');
     const [vendor_id, setVendorId] = useState('');
     const [vendor, setVendor] = useState({});
     const [errors, setErrors] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();
     const [orderDetails, setOrderDetails] = useState({ prefix: '', number: '', po_date: Helper.getToday(), valid_until: '', ref_number: '' });

     useEffect(() => {
          getPurchaseNumber();
     }, [])

     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = orderDetails;
                    p['customer_id'] = vendor_id;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(PURCHASE_ORDER, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    navigate('/root/po');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (vendor_id === '') {
               Alert.error('Kindly select vendor');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...orderDetails };
          order[fieldName] = value;
          setOrderDetails(order);
     };

     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          setState(data.state_id);
          setVendor(data.vendor);
     }

     const getPurchaseNumber = async (e) => {
          const res = await httpClient.post(GET_PURCHASE_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setOrderDetails(prevOrderDetails => ({
                         ...prevOrderDetails,
                         number: result.number || '',
                         prefix: result.prefix || ''
                    }));
               }
          }
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="new_purchase_order" subTitle="purchase_orders" subTitleLink="root/po" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectVendor remitVendor={remitVendor} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-3'>
                                        <label htmlFor='number'>{t('number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={orderDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={orderDetails.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='po_date'>{t('po_date')}</label>
                                        <input id='po_date' value={orderDetails.po_date} type='date' name='po_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_date', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='valid_until'>{t('valid_until')}</label>
                                        <input id='valid_until' value={orderDetails.valid_until} type='date' name='valid_until' className='form-control form-control-sm' onChange={(e) => handleInputChange('valid_until', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='ref_number'>{t('ref_number')}</label>
                                        <input id='ref_number' value={orderDetails.ref_number} type='text' name='ref_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('ref_number', e)} />
                                   </div>
                              </div>
                              <ProductCal title="purchase_order" onSubmit={handelSubmit} customer={vendor} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
